import {
  LayoutDashboard, Users, UserCheck, UserCog, Package,
  FileText, Settings, Wrench, Hammer, Printer, SlidersHorizontal,
  Warehouse, Box, ArrowRightLeft, BarChart3, Truck,
  CalendarClock, FolderOpen, ClipboardList, Calendar, ShieldCheck,
  FileSpreadsheet, TrendingUp
} from 'lucide-react'

export interface NavItem {
  name: string
  href?: string
  icon: React.ElementType
  badge?: number
  children?: NavChildItem[]
}

export interface NavChildItem {
  name: string
  href: string
  icon: React.ElementType
}

export interface FlatNavItem {
  name: string
  href: string
  icon: React.ElementType
  category?: string
  badge?: number
}

export const navigation: NavItem[] = [
  { name: 'Dashboard', href: '/app', icon: LayoutDashboard },
  {
    name: 'Anagrafiche',
    icon: Users,
    children: [
      { name: 'Utenti', href: '/app/anagrafiche/utenti', icon: Users },
      { name: 'Clienti', href: '/app/anagrafiche/clienti', icon: UserCheck },
      { name: 'Fornitori', href: '/app/magazzino/fornitori', icon: Truck },
      { name: 'Personale', href: '/app/anagrafiche/personale', icon: UserCog },
      { name: 'Strumenti', href: '/app/anagrafiche/strumenti', icon: Wrench },
      { name: 'Listino', href: '/app/anagrafiche/listino', icon: Package },
    ],
  },
  { name: 'Offerte', href: '/app/offerte', icon: FileText },
  { name: 'Approvazioni', href: '/app/approvazioni', icon: ShieldCheck },
  { name: 'Commesse', href: '/app/commesse', icon: Hammer },
  { name: 'Calendario', href: '/app/calendario', icon: Calendar },
  { name: 'Scadenziario', href: '/app/scadenziario', icon: CalendarClock },
  { name: 'Fascicoli', href: '/app/fascicoli', icon: FolderOpen },
  { name: 'Riepiloghi', href: '/app/riepiloghi', icon: FileSpreadsheet },
  { name: 'Strategia', href: '/app/strategia', icon: TrendingUp },
  {
    name: 'Magazzino',
    icon: Warehouse,
    children: [
      { name: 'Articoli', href: '/app/magazzino/articoli', icon: Box },
      { name: 'Distinta Base', href: '/app/magazzino/distinta-base', icon: Package },
      { name: 'Movimenti', href: '/app/magazzino/movimenti', icon: ArrowRightLeft },
      { name: 'Giacenze', href: '/app/magazzino/giacenze', icon: BarChart3 },
    ],
  },
  {
    name: 'Configurazione',
    icon: Settings,
    children: [
      { name: 'Generale', href: '/app/configurazione/generale', icon: SlidersHorizontal },
      { name: 'Ambiente', href: '/app/configurazione/tariffe', icon: Settings },
      { name: 'Modelli Stampa', href: '/app/configurazione/modelli-stampa', icon: Printer },
      { name: 'Schede Dinamiche', href: '/app/configurazione/schede-dinamiche', icon: ClipboardList },
    ],
  },
]

export function flattenNavigation(nav: NavItem[]): FlatNavItem[] {
  const result: FlatNavItem[] = []
  for (const item of nav) {
    if (item.children) {
      for (const child of item.children) {
        result.push({ name: child.name, href: child.href, icon: child.icon, category: item.name })
      }
    } else if (item.href) {
      result.push({ name: item.name, href: item.href, icon: item.icon, badge: item.badge })
    }
  }
  return result
}

export interface MenuProps {
  navigation: NavItem[]
  user: { email?: string; username?: string } | null
  onLogout: () => void
}
